import { DoterSpecies, JoonColorExpanded } from "@joonapp/web-shared"

import { getParentAvatarImageUrls } from "../../util/util"

const ParentAvatar = ({
  avatar,
  size = 100,
  fullBody = false,
  backgroundColor = JoonColorExpanded.indigo100,
  className = "",
  style,
}: {
  avatar: DoterSpecies | null
  size?: number
  fullBody?: boolean
  backgroundColor?: string
  className?: string
  style?: React.CSSProperties
}) => {
  return (
    <div
      className={`relative flex-col items-center justify-start overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        userSelect: "none",
        pointerEvents: "none",
        ...style,
      }}
    >
      <div className="w-full h-full" style={{ backgroundColor }}>
        {avatar &&
          getParentAvatarImageUrls(avatar).map((image, index) => (
            <img
              src={image}
              alt={`avatar-${index}`}
              key={image}
              className="absolute top-0 left-0"
              style={{
                width: "100%",
                height: "100%",
                transform: fullBody ? "scale(1)" : "scale(1.35)",
                transformOrigin: "top",
              }}
            />
          ))}
      </div>
    </div>
  )
}

export default ParentAvatar
